import { createContext, useContext, useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const defaultSettings = {
  siteName: "DiscoverSvaneti",
  tagline: "Explore mountains, towers, and legends",
  contactEmail: "",
  instagramUrl: "",
  heroEyebrow: "Elevated Wilderness",
  heroTitle: "Discover Svaneti",
  heroSubtitle: "Explore mountains, towers, and legends",
  heroImageUrl: "https://res.cloudinary.com/dgi0bwach/image/upload/v1782231757/ChatGPT_Image_Jun_23_2026_08_18_55_PM_ole0o1.png",
  hotelsSectionImageUrl: "https://images.unsplash.com/photo-1508264165352-258db2ebd59b?w=1920&q=75&auto=format&fit=crop",
  categoriesTitle: "Browse the Region",
  footerCopyright: "Elevated Wilderness.",
  heroEyebrowKa: "",
  heroTitleKa: "",
  heroSubtitleKa: "",
  categoriesTitleKa: "",
};

const SiteSettingsContext = createContext(defaultSettings);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(defaultSettings);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const snap = await getDoc(doc(db, "siteSettings", "general"));

        if (snap.exists()) {
          setSettings({ ...defaultSettings, ...snap.data() });
        }
      } catch (err) {
        console.error("Error loading site settings:", err);
      }
    };

    loadSettings();
  }, []);

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}